module.exports = __webpack_public_path__ + "static/media/icon-5.3ae689a7.svg";